import { Route, Switch, useRouteMatch } from 'react-router-dom';
import React from 'react';
import { ReservationsView } from './reservations.view';
import { CreateReservationView } from './create/createReservation.view';
import { UpdateReservationView } from './create/updateReservation.view';
import { ProvideReservations } from './reservations.context';
import { ReservationsStartedView } from './reservationsStarted.view';
import { ReservationsArchivedView } from './reservationsArchived.view';
import { ReservationsTrashView } from './reservationsTrash.view';

/**
 * Routeur pour la gestion des réservations
 * 
 * Ce routeur gère la navigation entre :
 * - Vue des réservations futures (/futur)
 * - Vue des réservations actives (/active, /in-activity)
 * - Vue des réservations archivées (/archive)
 * - Vue de la corbeille (/trash, /gift-voucher, /cancelled, /wait-to-paid, /refunds)
 * - Création de réservation (/create)
 * - Modification de réservation (/:id)
 * 
 * Logique métier :
 * - Routage conditionnel selon le statut des réservations
 * - Provider de contexte pour partager l'état des réservations
 * - Support des différents statuts (futur, actif, archivé, supprimé)
 * - Gestion des actions spéciales (bons cadeaux, remboursements)
 * 
 * @returns Composant React du routeur des réservations
 */
export const ReservationRouter = () => {
  const { path } = useRouteMatch();

  return (
    <div>
      <ProvideReservations>
        <Switch>
          <Route path={`${path}/gift-voucher`}>
            <ReservationsTrashView />
          </Route>
          <Route path={`${path}/futur`}>
            <ReservationsView />
          </Route>
          <Route path={`${path}/cancelled`}>
            <ReservationsTrashView />
          </Route>
          <Route path={`${path}/active`}>
            <ReservationsStartedView />
          </Route>
          <Route path={`${path}/in-activity`}>
            <ReservationsStartedView />
          </Route>
          <Route path={`${path}/wait-to-paid`}>
            <ReservationsTrashView />
          </Route>
          <Route path={`${path}/refunds`}>
            <ReservationsTrashView />
          </Route>
          <Route path={`${path}/archive`}>
            <ReservationsArchivedView />
          </Route>
          <Route path={`${path}/trash`}>
            <ReservationsTrashView />
          </Route>
          <Route path={`${path}/create`}>
            <CreateReservationView />
          </Route>
          <Route path={`${path}/:id`}>
            <UpdateReservationView />
          </Route>
        </Switch>
      </ProvideReservations>
    </div>
  );
};
